export default "__VITE_ASSET__CawXp_EC__"